'use strict';

angular
    .module('aq.filters')
    .filter('addDays', function () {
        return function (date, offset) {
            return moment(date).add(offset, 'days');
        }
    });